module.exports = __webpack_public_path__ + "static/media/pp_colored_gaint_straw2.56cc5fb3.png";